import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['searchInput', 'xMark']

  clearSearchInput() {
    this.searchInputTarget.value = ''
    this.searchInputTarget.dispatchEvent(new Event('input'))
    this.xMarkTarget.classList.remove('opacity-100')
  }

  toggleXMark() {
    if (this.searchInputTarget.value.length > 0) {
      this.xMarkTarget.classList.add('opacity-100')
    } else {
      this.xMarkTarget.classList.remove('opacity-100')
    }
  }
}
